export const siteName = "韩国漫画";

export const topTicker = [
  { id: "t1", text: "今日同步更新 18 部新作" },
  { id: "t2", text: "人气榜周更 · 已刷新 06:00" },
  { id: "t3", text: "豆瓣高分榜新增 12 部" },
  { id: "t4", text: "完结必看合集已更新至 240 部" },
];

export const hotSearches = [
  "我独自升级",
  "全知读者视角",
  "神之塔",
  "剑尊归来",
  "甜蜜家园",
  "外貌至上主义",
];

export const navLinks = [
  { id: "n1", label: "推荐榜单", icon: "ri-trophy-line" },
  { id: "n2", label: "高分神作", icon: "ri-star-smile-line" },
  { id: "n3", label: "人气榜", icon: "ri-fire-line" },
  { id: "n4", label: "豆瓣高分", icon: "ri-douban-line" },
  { id: "n5", label: "题材合集", icon: "ri-layout-grid-line" },
  { id: "n6", label: "新作速递", icon: "ri-rocket-2-line" },
];

export const heroStats = [
  { id: "s1", value: "3,240", label: "收录作品", suffix: "部" },
  { id: "s2", value: "860", label: "高分神作", suffix: "部" },
  { id: "s3", value: "96", label: "题材合集", suffix: "个" },
  { id: "s4", value: "每日", label: "榜单更新", suffix: "" },
];

export const rankEntries = [
  {
    id: "r1",
    title: "高分神作榜",
    subtitle: "综合评分 9.0 以上",
    icon: "ri-star-smile-line",
    count: "860 部",
    tone: "primary",
    samples: ["我独自升级", "全知读者视角", "剑尊归来"],
  },
  {
    id: "r2",
    title: "人气飙升榜",
    subtitle: "近 7 日阅读增速",
    icon: "ri-fire-line",
    count: "120 部",
    tone: "accent",
    samples: ["神之塔", "外貌至上主义", "高校之神"],
  },
  {
    id: "r3",
    title: "豆瓣高分榜",
    subtitle: "口碑与讨论热度",
    icon: "ri-douban-line",
    count: "240 部",
    tone: "secondary",
    samples: ["甜蜜家园", "梨泰院Class", "月光雕刻师"],
  },
  {
    id: "r4",
    title: "完结必看榜",
    subtitle: "一口气读完系列",
    icon: "ri-checkbox-circle-line",
    count: "318 部",
    tone: "foreground",
    samples: ["纳米危机", "血之游戏", "回归者"],
  },
];

export const featuredPicks = [
  {
    id: "f1",
    rank: "01",
    title: "我独自升级",
    author: "Chugong / DUBU",
    genre: "热血 · 战斗 · 系统流",
    score: "9.6",
    status: "已完结",
    tags: ["升级流", "爽文", "画风炸裂"],
    summary:
      "从最弱猎人一路逆袭，凭借系统赋予的成长之力重写命运。节奏干脆、打斗分镜极具张力，是许多人入坑韩国漫画的第一部。",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20Korean%20manhwa%20cover%20illustration%20of%20a%20lone%20swordsman%20with%20a%20glowing%20blade%20standing%20on%20a%20ruined%20rooftop%20at%20dusk%2C%20bold%20graphic%20novel%20linework%2C%20cinematic%20lighting%2C%20warm%20vermilion%20and%20gold%20color%20grading%2C%20moody%20deep%20shadows%2C%20detailed%20character%20design%2C%20simple%20uncluttered%20dark%20background%2C%20high%20detail&width=600&height=820&seq=manhwa-cover-01&orientation=portrait",
  },
  {
    id: "f2",
    rank: "02",
    title: "全知读者视角",
    author: "sing N song / Sleepy-C",
    genre: "末世 · 悬疑 · 群像",
    score: "9.5",
    status: "连载中",
    tags: ["元叙事", "剧情神作", "反转多"],
    summary:
      "一个读完全书的普通读者，成了唯一知晓结局的人。层层反转的情感线与宏大的世界观，被无数读者称为“教科书级叙事”。",
    cover:
      "https://readdy.ai/api/search-image?query=Illustrated%20Korean%20manhwa%20cover%20of%20a%20determined%20young%20fighter%20in%20a%20dark%20long%20coat%20facing%20a%20towering%20monster%20silhouette%2C%20bold%20graphic%20novel%20style%2C%20dramatic%20rim%20lighting%2C%20warm%20amber%20and%20deep%20red%20palette%2C%20simple%20gradient%20dark%20background%2C%20cinematic%20composition%2C%20high%20detail&width=600&height=820&seq=manhwa-cover-02&orientation=portrait",
  },
  {
    id: "f3",
    rank: "03",
    title: "神之塔",
    author: "SIU",
    genre: "奇幻 · 冒险 · 成长",
    score: "9.3",
    status: "连载中",
    tags: ["世界观宏大", "长线神作", "角色立体"],
    summary:
      "为了追寻唯一的她，少年踏入了望不到顶端的塔。庞大设定与漫长伏线交织，是韩国漫画里少见的史诗级长篇。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20mysterious%20tower%20reaching%20into%20glowing%20clouds%20with%20a%20small%20climbing%20figure%2C%20bold%20graphic%20novel%20linework%2C%20warm%20orange%20and%20gold%20tones%20against%20cool%20shadows%2C%20cinematic%20scale%2C%20simple%20atmospheric%20background%2C%20high%20detail&width=600&height=820&seq=manhwa-cover-03&orientation=portrait",
  },
];

export const popularTabs = [
  { id: "day", label: "日榜" },
  { id: "week", label: "周榜" },
  { id: "month", label: "月榜" },
];

export const popularRanking = [
  {
    id: "p1",
    day: [
      { rank: 1, title: "我独自升级", author: "Chugong", genre: "热血", hot: "98.6", trend: "up" },
      { rank: 2, title: "外貌至上主义", author: "朴泰俊", genre: "校园", hot: "97.2", trend: "up" },
      { rank: 3, title: "剑尊归来", author: "飞鹭", genre: "修真", hot: "96.8", trend: "same" },
      { rank: 4, title: "神之塔", author: "SIU", genre: "奇幻", hot: "95.4", trend: "down" },
      { rank: 5, title: "全知读者视角", author: "sing N song", genre: "末世", hot: "94.9", trend: "up" },
      { rank: 6, title: "高校之神", author: "朴容济", genre: "格斗", hot: "93.1", trend: "same" },
      { rank: 7, title: "甜蜜家园", author: "金坎比", genre: "惊悚", hot: "92.5", trend: "up" },
      { rank: 8, title: "最强送货员", author: "张成乐", genre: "都市", hot: "91.8", trend: "down" },
    ],
    week: [
      { rank: 1, title: "全知读者视角", author: "sing N song", genre: "末世", hot: "99.1", trend: "up" },
      { rank: 2, title: "我独自升级", author: "Chugong", genre: "热血", hot: "98.4", trend: "same" },
      { rank: 3, title: "神之塔", author: "SIU", genre: "奇幻", hot: "97.0", trend: "up" },
      { rank: 4, title: "剑尊归来", author: "飞鹭", genre: "修真", hot: "96.2", trend: "down" },
      { rank: 5, title: "月下锻剑", author: "李贤秀", genre: "武侠", hot: "94.8", trend: "up" },
      { rank: 6, title: "外貌至上主义", author: "朴泰俊", genre: "校园", hot: "93.9", trend: "same" },
      { rank: 7, title: "回归者", author: "金成宰", genre: "重生", hot: "92.6", trend: "down" },
      { rank: 8, title: "纳米危机", author: "朴志勋", genre: "科幻", hot: "91.2", trend: "up" },
    ],
    month: [
      { rank: 1, title: "我独自升级", author: "Chugong", genre: "热血", hot: "99.4", trend: "same" },
      { rank: 2, title: "神之塔", author: "SIU", genre: "奇幻", hot: "98.7", trend: "up" },
      { rank: 3, title: "全知读者视角", author: "sing N song", genre: "末世", hot: "98.0", trend: "up" },
      { rank: 4, title: "甜蜜家园", author: "金坎比", genre: "惊悚", hot: "96.5", trend: "down" },
      { rank: 5, title: "剑尊归来", author: "飞鹭", genre: "修真", hot: "95.9", trend: "same" },
      { rank: 6, title: "梨泰院Class", author: "赵光镇", genre: "都市", hot: "94.3", trend: "up" },
      { rank: 7, title: "月光雕刻师", author: "南熙成", genre: "游戏", hot: "93.0", trend: "down" },
      { rank: 8, title: "血之游戏", author: "崔秀敏", genre: "悬疑", hot: "91.7", trend: "up" },
    ],
  },
];

export const doubanRanking = [
  { id: "d1", rank: 1, title: "全知读者视角", score: "9.6", votes: "12.8万", genre: "末世 · 玄幻", quote: "叙事结构的教科书，情感与宏大同时在线。" },
  { id: "d2", rank: 2, title: "我独自升级", score: "9.4", votes: "18.2万", genre: "热血 · 战斗", quote: "画风与节奏俱佳，爽感从头贯穿到尾。" },
  { id: "d3", rank: 3, title: "甜蜜家园", score: "9.2", votes: "9.4万", genre: "惊悚 · 末日", quote: "把恐惧拍进心里，人性的描写尤为锋利。" },
  { id: "d4", rank: 4, title: "神之塔", score: "9.1", votes: "7.6万", genre: "奇幻 · 冒险", quote: "世界观庞大到令人着迷，长线追更值得。" },
  { id: "d5", rank: 5, title: "梨泰院Class", score: "9.0", votes: "6.9万", genre: "都市 · 成长", quote: "关于坚持与尊严的都市寓言。" },
  { id: "d6", rank: 6, title: "月光雕刻师", score: "8.9", votes: "5.3万", genre: "游戏 · 奇幻", quote: "虚拟世界里的真实温度。" },
];

export const genres = [
  { id: "g1", name: "热血战斗", count: "412" },
  { id: "g2", name: "恋爱日常", count: "368" },
  { id: "g3", name: "玄幻修真", count: "297" },
  { id: "g4", name: "悬疑惊悚", count: "254" },
  { id: "g5", name: "校园青春", count: "221" },
  { id: "g6", name: "都市异能", count: "198" },
  { id: "g7", name: "末日废土", count: "176" },
  { id: "g8", name: "轻松搞笑", count: "163" },
  { id: "g9", name: "治愈温情", count: "142" },
  { id: "g10", name: "体育竞技", count: "118" },
  { id: "g11", name: "虚拟游戏", count: "104" },
  { id: "g12", name: "历史架空", count: "86" },
];

export const collections = [
  {
    id: "c1",
    title: "熬夜一口气看完",
    desc: "节奏紧凑、钩子密集，从第一话就停不下来。适合周末整块时间一口气刷完。",
    count: "42 部作品",
    tag: "高能连载",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20illustrated%20banner%20of%20stacked%20glowing%20manhwa%20volumes%20on%20a%20dark%20wooden%20desk%20lit%20by%20warm%20lamp%20light%2C%20graphic%20novel%20style%2C%20cozy%20reading%20mood%2C%20warm%20amber%20and%20vermilion%20palette%2C%20simple%20blurred%20dark%20background%2C%20cinematic%2C%20high%20detail&width=900&height=620&seq=manhwa-coll-01&orientation=landscape",
  },
  {
    id: "c2",
    title: "画风封神合集",
    desc: "分镜、上色与动作设计都在线的视觉系作品，适合收藏高清彩页慢慢欣赏。",
    count: "36 部作品",
    tag: "视觉系",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20illustrated%20banner%20showing%20a%20montage%20of%20dramatic%20Korean%20manhwa%20action%20panels%20with%20speed%20lines%20and%20glowing%20effects%2C%20bold%20graphic%20novel%20style%2C%20warm%20gold%20and%20red%20color%20grade%2C%20abstract%20simple%20dark%20background%2C%20cinematic%2C%20high%20detail&width=900&height=620&seq=manhwa-coll-02&orientation=landscape",
  },
  {
    id: "c3",
    title: "悬疑推理精选",
    desc: "层层反转、处处伏笔，一边追更一边推理，和朋友聊剧情能聊到深夜。",
    count: "28 部作品",
    tag: "烧脑向",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20illustrated%20banner%20of%20a%20rain-soaked%20neon%20alley%20at%20night%20with%20a%20silhouetted%20figure%2C%20cinematic%20Korean%20manhwa%20atmosphere%2C%20bold%20graphic%20style%2C%20warm%20amber%20highlights%20against%20deep%20shadows%2C%20simple%20abstract%20background%2C%20high%20detail&width=900&height=620&seq=manhwa-coll-03&orientation=landscape",
  },
];

export const updateFeed = [
  { id: "u1", title: "剑尊归来", chapter: "第 218 话", time: "10 分钟前", genre: "修真" },
  { id: "u2", title: "全知读者视角", chapter: "第 214 话", time: "32 分钟前", genre: "末世" },
  { id: "u3", title: "外貌至上主义", chapter: "第 512 话", time: "1 小时前", genre: "校园" },
  { id: "u4", title: "最强送货员", chapter: "第 96 话", time: "2 小时前", genre: "都市" },
  { id: "u5", title: "神之塔", chapter: "第 634 话", time: "3 小时前", genre: "奇幻" },
  { id: "u6", title: "月下锻剑", chapter: "第 77 话", time: "4 小时前", genre: "武侠" },
];

export const faqs = [
  {
    id: "q1",
    q: "韩国漫画和日本漫画有什么区别？",
    a: "韩国漫画（Manhwa）通常采用竖屏条漫形式，适合手机上下滑动阅读，节奏偏向连续高频更新，题材上都市、系统流、末日与游戏元素更常见，整体画风也更大面积上色。",
  },
  {
    id: "q2",
    q: "榜单里的评分和人气是怎么来的？",
    a: "高分神作榜参考综合评分，人气榜统计近一段时间的阅读增速与讨论热度，豆瓣高分榜则汇总读者口碑。三个榜角度不同，可以交叉参考，避免只看单一维度。",
  },
  {
    id: "q3",
    q: "刚入坑应该先看哪几部？",
    a: "如果喜欢爽快节奏，可以从《我独自升级》开始；想看叙事和世界观，推荐《全知读者视角》与《神之塔》；偏爱悬疑惊悚则试试《甜蜜家园》。先挑一部对上口味，再顺着合集扩展。",
  },
  {
    id: "q4",
    q: "榜单多久更新一次？",
    a: "高分榜与豆瓣榜每周复核一次，人气榜每日刷新，新作速递随作品更新同步。完结必看合集会持续补充新完结的高口碑作品。",
  },
];

export const footerColumns = [
  {
    id: "fc1",
    title: "热门榜单",
    links: ["高分神作榜", "人气飙升榜", "豆瓣高分榜", "完结必看榜", "新作速递"],
  },
  {
    id: "fc2",
    title: "题材索引",
    links: ["热血战斗", "玄幻修真", "悬疑惊悚", "都市异能", "治愈温情"],
  },
  {
    id: "fc3",
    title: "精选合集",
    links: ["熬夜一口气看完", "画风封神合集", "悬疑推理精选", "入坑首选清单", "长篇史诗推荐"],
  },
  {
    id: "fc4",
    title: "关于本站",
    links: ["榜单说明", "收录标准", "读者反馈", "免责声明"],
  },
];